export const BlinkDot = ({ testid, tone = "orange" }) => (
  <span data-testid={testid} className="relative inline-flex h-3 w-3 shrink-0">
    <span className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 ${tone === "orange" ? "bg-orange-400" : "bg-red-400"}`} />
    <span className={`relative inline-flex h-3 w-3 rounded-full ${tone === "orange" ? "bg-orange-500" : "bg-red-500"}`} />
  </span>
);
